import { Badge, Button, Descriptions, Icon } from "antd";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { generate_query_set, handleApiExceptions } from "../../../../app_methods";
import { VENDOR_APPROVAL_STATUS } from "../../../../constants";
import { EaseDrawer } from "../../../../libs/EaseDrawer";
import { EaseTable } from "../../../../libs/EaseTable";
import { Vendor } from "../../../../models/vendorPayouts";
import { updateCurrentUserAction } from "../../../../redux/actions";
import { Text4 } from "../../../../styles";
import { BulkUploadModal, ContentCard } from "../../../Common";
import { VendorModal } from "../../../Common/VendorPayouts/Modals/Vendor";
import { CreatePermissionHoc, PermissionHoc } from "../../../HOC";
import { getVendorColumns, vendorTableFilterNodes } from "./constants";
import { VendorDetailsDrawer } from "./details";
import { connect } from "react-redux";

const VendorsList = (props) => {
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    showTotal: (total) => `Total ${total} Records`,
  });
  const [filters, setFilters] = useState({});
  const [showVendorModal, setshowVendorModal] = useState(false);
  const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
  const [showVendorDetailsDrawer, setShowVendorDetailsDrawer] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({});
  const [vendors, setVendors] = useState([]);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

  const PermissableButton = PermissionHoc(Button, "", { is_component: true, fallbackComponent: null, });

  const fetchList = async (_pagination = pagination, _filters = filters) => {
    setIsTableLoading(true);
    const response = await Vendor.list({
      ...{ pageSize: _pagination.pageSize, current: _pagination.current },
      ..._filters,
    });
    if (!response.success) {
      setIsTableLoading(false);
      handleApiExceptions(response);
      return;
    }

    let queryset = generate_query_set(Vendor, response.data.results);
    setVendors(queryset);
    setPagination({ ...pagination, total: response.data.count });
    setIsTableLoading(false);
    setSelectedVendor(new Vendor(response.data.results.find((vendor) => vendor.id == selectedVendor.id)));

  };

  useEffect(() => {
    props.onChildMount();
    fetchList({ ...pagination }, { ...filters });
  }, []);

  const toggleVendorModal = (vendor = {}) => {
    setSelectedVendor(vendor);
    setshowVendorModal(!showVendorModal);
  };

  const toggleVendorDetailsDrawer = (obj = {}) => {
    setSelectedVendor(obj);
    setShowVendorDetailsDrawer(!showVendorDetailsDrawer);
  };

  const toggleStatusInfoDrawer = () => {
    setShowStatusInfoDrawer(!showStatusInfoDrawer);
  };

  const toggleBulkUploadModal = () => {
    setShowBulkUploadModal(!showBulkUploadModal);
  };

  const onVendorSave = () => {
    toggleVendorModal();
    fetchList(pagination, filters);
  }

  const tableColumns = getVendorColumns({
    toggleVendorDetailsDrawer,
    toggleStatusInfoDrawer,
    toggleVendorModal
  });

  const CreateButton = CreatePermissionHoc({create_permission:'VENDOR_WRITE',bulk_permission:'BENEFICIARIES_BULK_UPLOAD'}, { onCreateClick: toggleVendorModal, onBulkClick: toggleBulkUploadModal, createText: <><Icon type="plus" /> Add Vendor </>, bulkText:"Bulk Upload" });

  let filterNodes = vendorTableFilterNodes();

  const handleTableChange = (tableInfo) => {
    if (tableInfo.trigger == "columns") return;
    let _pagination = tableInfo.pagination;
    if (tableInfo.trigger == "filters") _pagination.current = 1;
    setPagination(_pagination);
    setFilters(tableInfo.filters);
    fetchList(_pagination, tableInfo.filters);
  };

  return (
    <div>
      <ContentCard className="p-3">
        <div className="w-100 d-flex justify-content-end">
          <CreateButton />
        </div>
        <EaseTable
          rowKey="uuid"
          loading={isTableLoading}
          data={vendors}
          columns={tableColumns}
          fixedSelectable={!isMobile}
          handleTableChange={handleTableChange}
          pagination={pagination}
          totalRecords={pagination.total}
          filterNodes={filterNodes}
        />

        <VendorModal
          visible={showVendorModal}
          toggleVendorModal={() => toggleVendorModal()}
          onVendorSave={onVendorSave}
          vendor={selectedVendor}
        />
      </ContentCard>

      <EaseDrawer
        visible={showStatusInfoDrawer}
        onClose={toggleStatusInfoDrawer}
        hideFooter
        title="Vendor Statuses"
        width={500}
      >
        <Descriptions
          bordered
          className="mt-3"
          size="small"
          layout="horizontal"
          column={1}
        >
          {Object.keys(VENDOR_APPROVAL_STATUS).map((key, index) => {
            return (
              <Descriptions.Item
                label={
                  <Badge
                    color={VENDOR_APPROVAL_STATUS[key].color}
                    text={
                      <Text4>{VENDOR_APPROVAL_STATUS[key].label}</Text4>
                    }
                  />
                }
              >
                {VENDOR_APPROVAL_STATUS[key].description}
              </Descriptions.Item>
            );
          })}
        </Descriptions>
      </EaseDrawer>


      <VendorDetailsDrawer
        visible={showVendorDetailsDrawer}
        onClose={toggleVendorDetailsDrawer}
        vendor={selectedVendor}
        fetchList={fetchList}
      />
      <BulkUploadModal
        history={props.history}
        visible={showBulkUploadModal}
        toggleBulkUploadModal={toggleBulkUploadModal}
        onSuccess={() => fetchList(pagination, filters)}
        type="vendor"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHoc(VendorsList, "VENDOR_READ"));
